import React from "react";
import { Empty } from "antd";
import TabbedDynamicTable from "../../../../Components/TabbedDynamicTable";
import ConectarWhatsapp from "./ConectarWhatsapp";
import AsignarConversaciones from "./AsignarConversaciones";
import BibliotecaElementos from "./Biblioteca/BibliotecaElementos";
import BibliotecaUbicaciones from "./Biblioteca/BibliotecaUbicaciones";
import CamposDefaultInsumo from "./CamposDefaultInsumo";
import BibliotecaPlantillas from "./Biblioteca/BibliotecaPlantillas";
import { WA } from "../theme";

// Configuración de Whatsapp en pestañas 
// - Conexión (Embedded Signup): solo quien puede configurar.
// - Asignación de conversaciones: solo quien puede asignar chats.
// - Biblioteca de elementos: solo quien puede configurar.
const VistaConfiguracion = ({ headersToken, empresaId, puedeConfigurar, puedeAsignar, puedeElementos, puedePlantillas, puedeMarcarPrincipal }) => {
  const tabs = [];

  if (puedeConfigurar) {
    tabs.push({ key: "conexion", label: "Conexión", customContent: <ConectarWhatsapp puedeMarcarPrincipal={puedeMarcarPrincipal} /> });
  }
  if (puedeAsignar) {
    tabs.push({
      key: "asignacion",
      label: "Asignación de conversaciones",
      customContent: <AsignarConversaciones headersToken={headersToken} empresaId={empresaId} />,
    });
  }
  if (puedeElementos) {
    tabs.push({
      key: "biblioteca",
      label: "Biblioteca de elementos",
      customContent: <BibliotecaElementos headersToken={headersToken} empresaId={empresaId} />,
    });
    tabs.push({
      key: "ubicaciones",
      label: "Ubicaciones",
      customContent: <BibliotecaUbicaciones headersToken={headersToken} empresaId={empresaId} />,
    });
    tabs.push({
      key: "camposInsumo",
      label: "Campos de insumo",
      customContent: <CamposDefaultInsumo headersToken={headersToken} empresaId={empresaId} />,
    });
  }
  if (puedePlantillas) {
    tabs.push({
      key: "plantillas",
      label: "Plantillas",
      customContent: <BibliotecaPlantillas headersToken={headersToken} empresaId={empresaId} />,
    });
  }

  if (!tabs.length) {
    return <Empty description="No tienes secciones de configuración disponibles." style={{ padding: 40 }} />;
  }

  return (
    <div
      style={{
        border: `1px solid ${WA.border}`,
        borderRadius: 12,
        backgroundColor: WA.surface,
        padding: 16,
      }}
    >
      <TabbedDynamicTable tabs={tabs} defaultActiveKey={tabs[0].key} />
    </div>
  );
};

export default VistaConfiguracion;
